import { Issue, IssueFormData, IssueFilters } from '../types/issue';
import api from './api';

export const issueService = {
  // Получение всех выпусков
  getAllIssues: async (filters?: IssueFilters): Promise<Issue[]> => {
    const response = await api.get('/issues', { params: filters });
    return response.data as Issue[];
  },

  // Получение выпуска по ID
  getIssueById: async (id: number): Promise<Issue> => {
    const response = await api.get(`/issues/${id}`);
    return response.data as Issue;
  },

  // Создание нового выпуска
  createIssue: async (data: IssueFormData): Promise<Issue> => {
    const response = await api.post('/issues', data);
    return response.data as Issue;
  },

  // Обновление выпуска
  updateIssue: async (id: number, data: IssueFormData): Promise<Issue> => {
    const response = await api.put(`/issues/${id}`, data);
    return response.data as Issue;
  },

  // Удаление выпуска
  deleteIssue: async (id: number): Promise<void> => {
    await api.delete(`/issues/${id}`);
  },

  // Увеличение счетчика скачиваний
  incrementDownloads: async (id: number): Promise<Issue> => {
    const response = await api.post(`/issues/${id}/download`);
    return response.data as Issue;
  },

  // Публикация выпуска
  publishIssue: async (id: number): Promise<Issue> => {
    const response = await api.post(`/issues/${id}/publish`);
    return response.data as Issue;
  },

  // Архивирование выпуска
  archiveIssue: async (id: number): Promise<Issue> => {
    const response = await api.post(`/issues/${id}/archive`);
    return response.data as Issue;
  }
}; 